import { useEffect, useState } from "react";
// reactstrap components
import {
  Button,
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
// core components
import { Link, useNavigate } from "react-router-dom";
import TemplateAPI from "api/api/TemplateAPI";
import EditTemplateInfoModal from "components/Modals/EditTemplateInfoModal";
import AppHelmet from "../../components/AppComponents/AppHelmet";
import BasicTableView from "../supportal/CloudListView/BasicTableView";

const initialModals = {
  createModal: false,
};

const CRMDefaultTemplateListView = ({ urlStart }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [modals, setModals] = useState(initialModals);
  const [submitting, setSubmitting] = useState(false);
  const [createError, setCreateError] = useState(null);
  const [deleteError, setDeleteError] = useState(null);
  urlStart = urlStart || "/supportal";

  const getTemplates = async () => {
    TemplateAPI.getCRMTemplates()
      .then(
        (data) => {
          setTemplates(data.data.data.templates);
        },
        (err) => {
          console.error(err);
        }
      )
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getTemplates();
  }, []);

  const handleError = (error, setError) => {
    setError(error);
    setTimeout(() => setError(null), 4000);
  };

  const create = (values, setValues, initialValues) => {
    setSubmitting(true);

    TemplateAPI.createCRMTemplate(values.Name, values.Description)
      .then(
        (data) => {
          let newTemplate = data.data.data.template;

          setTemplates((prev) => [...prev, newTemplate]);

          setValues(initialValues);

          toggleModal("createModal");
        },
        (error) => {
          console.log(error.response);
          if (error.response && error.response.status === 409) {
            let error =
              "A template with that name already exists. Modify name to continue.";
            handleError(error, setCreateError);
          } else {
            let error =
              "We were unable to create the template. Please try again.";
            handleError(error, setCreateError);
          }
          console.error(error);
        }
      )
      .finally(() => {
        setSubmitting(false);
      });
  };

  const toggleModal = (name) => {
    setModals((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  return (
    <>
      <AppHelmet title="Cloud Templates - GrowthCloud.com" />
      <div className="header pb-6">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="auto" md="12">
                <h6 className="h2 mb-0">Cloud Templates</h6>{" "}
                <Breadcrumb
                  className="d-none d-md-block mt-1"
                  listClassName="breadcrumb-links"
                >
                  <BreadcrumbItem>
                    <Link to={urlStart}>
                      <i className="mdi mdi-rocket" />
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Cloud Templates</BreadcrumbItem>
                </Breadcrumb>
              </Col>
              <Col className="text-lg-right mt-3 mt-lg-0" lg="" md="12">
                <Button
                  color="primary"
                  onClick={() => toggleModal("createModal")}
                >
                  New
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <hr className="mt-0 mb-4" />
        <BasicTableView
          items={templates}
          loading={loading}
          title="Cloud Templates"
          getItemTitle={(t) => t?.Name}
          getItemSubtitle={(t) => t?.Description || "No description provided."}
          onClick={(t) => navigate(`${urlStart}/global/templates/${t.id}`)}
        />
      </Container>
      <EditTemplateInfoModal
        open={modals.createModal}
        toggle={() => toggleModal("createModal")}
        onUpdate={create}
        submitting={submitting}
        error={createError}
        data={null}
      />
    </>
  );
};

export default CRMDefaultTemplateListView;
